import {Module} from '@mamdev/cad.static-next-lib';

export default class Article extends Module {
  // Init. from DOM.
  static attachTo(root: HTMLElement): Article {
    return new Article(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'article';
  }

  // Start the module.
  start() {
    try {
      this.log('article init');
      this.seoTags();
    } catch (e) {
      this.logUnknownError(e, true);
    }
  }

  // click on tags below article (SEO)
  seoTags() {
    const tags = (this.root_.getElementsByClassName('tags')[0]) as HTMLElement;

    if (tags) {
      const searchBaseUrl = tags.dataset.searchbaseurl;
      if (searchBaseUrl) {
        tags.querySelectorAll('span').forEach(span => {
          span.addEventListener('click', () => {
            const kw = span.textContent;
            if (kw) {
              const decodeURL = atob(searchBaseUrl);
              const searchUrl = decodeURL + encodeURIComponent(kw);
              window.open(searchUrl);
            }
          });
        });
      }
    }
  }
}
